export const config = {
  apiBaseUrl: 'http://api.tehranecoat.ir/',
  apiUrl: 'http://api.tehranecoat.ir/api/',
  // uploadsUrl: 'http://newapi.uobour.com/uploads/',
};
